import './style.scss';
import { ApplySymbolInput } from '../hooks';
import { DomesticRealEstateFullInfo } from 'views/pages/symbol/module/fullInfo';
import { DomesticRealEstateThumbnail } from 'views/pages/symbol/module/thumbnail';
import { DomesticRealEstateBasicInfo } from 'views/pages/symbol/module/basicInfo';
import { alignTarget, alignType, Description, labelColor, labelSize } from 'views/mutual/description';
import { Caption } from 'views/mutual/caption';
import { CheckLabel } from 'views/mutual/checkLabel';
import { Button, ButtonFill, ButtonSize } from 'views/mutual/button';
import { FormikProps } from 'formik';
import { useCustomLocationName } from 'views/mutual/location/hooks';
import { useMessageModal } from 'views/mutual/modal/messageModal/hooks';
import { LotInput_ApplyDomesticRealEstate, LotInput_ConfirmationTitle } from 'views/pages/symbol/module/lotInput';
import { DomesticRealEstateSymbolDetailInfo } from 'views/utils/graphql/graphql';

type DomesticRealEstateSymbolDetailProps = {
  symbolDetail: DomesticRealEstateSymbolDetailInfo;
  formik: FormikProps<ApplySymbolInput>;
  canApplySymbol: boolean;
  impossobleDetailErrorText?: string;
  check1Props: any;
  check2Props: any;
  check3Props: any;
  check4Props: any;
};

export const DomesticRealEstateSymbolDetail = ({
  symbolDetail,
  formik,
  canApplySymbol,
  impossobleDetailErrorText,
  check1Props,
  check2Props,
  check3Props,
  check4Props,
}: DomesticRealEstateSymbolDetailProps) => {
  useCustomLocationName(symbolDetail.ProductName!);
  const { modalProps, showMessageModal } = useMessageModal();

  return (
    <div className="domesticRealEstate">
      <div className="programDetail">
        <div className='programDetail_basicInfo_wrapper'>
        {impossobleDetailErrorText && (
        <div className="disableApplyDescription">
          <Description label={impossobleDetailErrorText} labelColor={labelColor.red} labelSize={labelSize.large} />
        </div>
      )}
          <Description
            labelColor={labelColor.black}
            labelSize={labelSize.extraLarge}
            label="契約締結前 確認事項"
            alignInfo={
              {
              target : alignTarget.sp,
              type : alignType.center        
            }}
          />
        
          <div className="programDetail_card_wrapper">
            <div className="programDetail_request">
              <LotInput_ApplyDomesticRealEstate
                title="申込金額"
                realEstateBeneficiaryRightPrice={symbolDetail.RealEstateBeneficiaryRightPrice!}
                realEstatePriceEquivalent={symbolDetail.RealEstatePriceEquivalent!}
                consumptionTaxAmount={symbolDetail.ConsumptionTaxAmount!}
                repairReserveFundEquivalent={symbolDetail.RepairReserveFundEquivalent!}
                requiredWorkingCapitalReserveEquivalent={symbolDetail.RequiredWorkingCapitalReserveEquivalent!}
                priceInputProps={{
                  name: 'amount',
                  label: '申込個数',
                  price: formik.values.amount,
                  onChange: () => {},
                  unitName: '',
                  disabled: true,
                  placeholder: '',
                  error: formik.touched.amount ? formik.errors.amount : '',
                }}
              />
            </div>
            <div className='programDetail_confrim'>
              <LotInput_ConfirmationTitle title="確認事項" />
              <div className="programDetail_request">
                <div className="description">
                  <Description
                    labelColor={labelColor.red}
                    labelSize={labelSize.medium}
                    label="すべての確認事項にチェックを入れると「申込内容の確認へ」がクリックできます。"
                  />
                  <Description
                    labelColor={labelColor.gray}
                    labelSize={labelSize.small}
                    label="※書面のダウンロードが必要な場合はブラウザに表示した後、ブラウザの機能で保存可能です。"
                  />
                </div>
                <CheckLabel
                  before="本信託受益権の売買契約について、「契約締結前交付書面」の電子交付を受け、宅地建物取引士から宅地建物取引士証を提示された上で、その記載内容の説明を受け、内容を十分に理解しました。"
                  {...check1Props}
                />

                <CheckLabel
                  before="「税制改正に関する説明事項」の電子交付を受けるとともに、宅地建物取引士から記載内容の説明を受け、内容を十分に理解しました。"
                  {...check2Props}
                />
                <CheckLabel before="本申込みの撤回ができないことを確認しました。" {...check3Props} />
                <CheckLabel
                  before="本信託受益権の購入にあたり、信託不動産登記における受益者の変更に係る登記申請手続きを留保し、私（当社）の氏名および住所（本店所在地）が登記上公示されないことを希望します。"
                  {...check4Props}
                />
                <Description
                  labelColor={labelColor.black}
                  labelSize={labelSize.medium}
                  label={
                    <>
                      契約締結日に75歳以上であるお客様は、原則としてオンライン取引サービスでのご契約はできません。恐れ入りますが、該当されるお客様はお取引店までご連絡ください。
                    </>
                  }
                />
                <Button
                  label="申込内容の確認へ"
                  buttonFill={ButtonFill.black}
                  buttonSize={ButtonSize.large}
                  disable={!canApplySymbol}
                  onClick={() => formik.handleSubmit()}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
